import { useMutation, useQueryClient } from 'react-query';

import { putSetActivationSignalStatus as setStatus } from './../../api/traps/MultiCatchTrap/putSetStatusActivationSignal';

const useSetActivationSignalStatus = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: putSetActivationSignalStatus,
    isLoading,
  } = useMutation(setStatus, {
    onSuccess: () => {
      queryClient.invalidateQueries('setActivationSignalStatus');
    },
  });

  return {
    isSuccess,
    putSetActivationSignalStatus,
    isLoading,
  };
};

export default useSetActivationSignalStatus;
